import { JsonObject, JsonProperty } from 'json2typescript';
import { EmptyControl, Required } from '@hvlng/framework-bff/core';
import { HvlDateConverter } from '@hvlng/framework-bff/util';

@JsonObject('KovanHrPersonnelManagerInfoModel')
export class PersonnelManagerInfoModel {
    @Required()
    @JsonProperty('beginDate', HvlDateConverter, true)
    beginDate: Date = null;

    @Required()
    @JsonProperty('endDate', HvlDateConverter, true)
    endDate: Date = null;

    @EmptyControl()
    @JsonProperty('peopleId', Number, true)
    peopleId: number = null;

    @EmptyControl()
    @JsonProperty('name', String, true)
    name: string = null;

    @EmptyControl()
    @JsonProperty('surname', String, true)
    surname: string = null;

    @EmptyControl()
    @JsonProperty('registryNumber', String, true)
    registryNumber: string = null;

    @EmptyControl()
    @JsonProperty('managerLevel', Number, true)
    managerLevel: number = null;

    @EmptyControl()
    @JsonProperty('identificationNumber', String, true)
    identificationNumber: string = null;

    @EmptyControl()
    @JsonProperty('peopleUuid', String, true)
    peopleUuid: string = null;
}
